//imports
import Headroom from "headroom.js";
import GLightbox from 'glightbox';
import Lenis from 'lenis';
import 'slick-carousel';
import AOS from 'aos';
import Rellax from 'rellax';

// lazysizes
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';



$(document).ready(function($){

    var rellax = new Rellax('.rellax');

  // Tabs Block
  $(document).on('click', '.tabs-block__nav .nav-link', function () {
    const $btn     = $(this);
    const $nav     = $btn.closest('.tabs-block__nav');
    const $content = $nav.next('.tabs-block__content');
    const target   = $btn.data('target');

    $nav.find('.nav-link').removeClass('active').attr('aria-selected', 'false');
    $btn.addClass('active').attr('aria-selected', 'true');

    $content.find('.tab-pane').removeClass('show active');
    $content.find(target).addClass('show active');
  });

  // jQuery-Version (kompakt)
  $('.faq__item').each(function () {
  const $d = $(this);                          // <details>
  const $q = $d.find('.faq__question').first(); // <summary>
  const $a = $d.find('.faq__answer').first();   // Antwort-Container

  if (!$q.length || !$a.length) return;

  // Initialzustand
  if ($d.prop('open')) {
    $a.show().css('opacity', 1);
  } else {
    $a.hide().css('opacity', 0);
  }

  // Click/Tap
  $q.on('click', function (e) {
    e.preventDefault(); // verhindert das native <details>-Toggle
    if (!$d.prop('open')) {
      $d.prop('open', true);                    // State sichtbar (Icon etc.)
      $a.stop(true, true).css('opacity', 1).slideDown(280);
    } else {
      $a.stop(true, true).slideUp(280, function () {
        $a.css('opacity', 0);
        $d.prop('open', false);
      });
    }
  });

  // Tastatur-Unterstützung, falls <summary> nicht reicht/ersetzt wurde
  if (!/summary/i.test($q[0].tagName)) {
    $q.attr({ role: 'button', tabindex: 0 }).on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $q.click(); }
    });
  }
});






  // Initialize Lenis
const lenis = new Lenis({
    autoRaf: true,
  anchors: {
    offset: 0,
    onComplete: ()=>{
      console.log('scrolled to anchor')
    }
  }
})

// Listen for the scroll event and log the event data
lenis.on('scroll', (e) => {
  console.log(e);
    if (e.scroll > 1) {
    document.body.classList.add('scrolled');
  } else {
    document.body.classList.remove('scrolled');
  }
});


     
  

  //GLIGHTBOX
 const lightbox = GLightbox();

  var options = {

     offset: {
         up: 0,
         down: 0
     },
     // scroll tolerance in px before state changes
     tolerance : 0,

 };

 //HEADROOM JS
  var element = document.querySelector("header");
  var headroom  = new Headroom(element,options);
  // initialise
  headroom.init();

  //AOS
  AOS.init();


  //SLICK SLIDER
  $('.testimonials__wrapper').slick({
    infinite: true,
    dots: true,
    speed: 500,
    fade: true,
     slidesToShow: 1,
  slidesToScroll: 1,
    cssEase: 'linear',
    arrows : true,
  });

 

  

 // External controls
  $('.prev').on('click', function(){
   $('.testimonials__wrapper').slick('slickPrev');
  });

  $('.next').on('click', function(){
    $('.testimonials__wrapper').slick('slickNext');
  });

   



});







// Accessible Burger Menu (standalone)
// Erwartet HTML-Struktur:
// <nav id="site-navigation">
//   <button class="menu-toggle" aria-expanded="false" aria-controls="primary-menu">Menü</button>
//   <ul id="primary-menu" class="menu">
//     ...
//   </ul>
// </nav>

// Accessible Burger Menu (standalone)
// Erwartet HTML-Struktur:
// <nav id="site-navigation">
//   <button class="menu-toggle" aria-expanded="false" aria-controls="primary-menu">Menü</button>
//   <ul id="primary-menu" class="menu">
//     ...
//   </ul>
// </nav>

(function initAccessibleBurger() {
  const siteNavigation = document.getElementById('site-navigation');
  if (!siteNavigation) return;

  const button = siteNavigation.querySelector('button');
  const menu   = siteNavigation.querySelector('ul');
  if (!button || !menu) return;

  // Grundklassen/ARIA absichern
  if (!menu.classList.contains('nav-menu')) menu.classList.add('nav-menu');
  if (!button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded', 'false');

  // aria-controls setzen, falls fehlend
  if (!button.getAttribute('aria-controls')) {
    // Falls das <ul> keine ID hat, generieren
    if (!menu.id) menu.id = 'primary-menu';
    button.setAttribute('aria-controls', menu.id);
  }

  // Toggle öffnen/schließen
  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    siteNavigation.classList.toggle('toggled', !expanded);

    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  });

  menu.addEventListener('click', (e) => {
  const a = e.target.closest('a');
  if (!a) return;

  siteNavigation.classList.remove('toggled');
  button.setAttribute('aria-expanded', 'false');
});

  // Klick außerhalb: schließen
  document.addEventListener('click', (event) => {
    if (!siteNavigation.contains(event.target)) {
      siteNavigation.classList.remove('toggled');
      button.setAttribute('aria-expanded', 'false');
    }
  });

  // Fokus-Management für Keyboard-Nutzer:innen
  const links = menu.querySelectorAll('a');
  const linksWithChildren = menu.querySelectorAll(
    '.menu-item-has-children > a, .page_item_has_children > a'
  );

  links.forEach((link) => {
    link.addEventListener('focus', toggleFocus, true);
    link.addEventListener('blur',  toggleFocus, true);
  });

  // Touch: erstes Tippen fokussiert/öffnet Untermenü
  linksWithChildren.forEach((link) => {
    link.addEventListener('touchstart', toggleFocus, { passive: false });
  });

  function toggleFocus(event) {
    if (event.type === 'focus' || event.type === 'blur') {
      let el = this;
      while (el && !el.classList.contains('nav-menu')) {
        if (el.tagName && el.tagName.toLowerCase() === 'li') {
          el.classList.toggle('focus', event.type === 'focus');
        }
        el = el.parentNode;
      }
    }
    if (event.type === 'touchstart') {
      const menuItem = this.parentNode; // li
      event.preventDefault();
      Array.from(menuItem.parentNode.children).forEach((li) => {
        if (li !== menuItem) li.classList.remove('focus');
      });
      menuItem.classList.toggle('focus');
    }
  }
})();




const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

function animateDonut(el){
  const strong   = el.querySelector('strong');
  const small    = el.querySelector('small');

  const target   = clamp(Number(el.dataset.percent || 0), 0, 100);
  const delay    = Number(el.dataset.delay || 0);
  const duration = reduce ? 0 : Number(el.dataset.duration || 900);

  const aLabel   = el.dataset.a || 'A';
  const bLabel   = el.dataset.b || 'B';
  small.textContent = `${aLabel}`;

  const t0 = performance.now() + delay;
  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }

  function tick(now){
    if(now < t0){ requestAnimationFrame(tick); return; }
    const k = duration ? Math.min(1, (now - t0) / duration) : 1;
    const e = reduce ? 1 : easeOutCubic(k);

    const v = target * e;
    el.style.setProperty('--p', v);
    strong.textContent = `${Math.round(v)}%`;

    if(k < 1 && !reduce) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

function clamp(n, min, max){ return Math.min(max, Math.max(min, n)); }

// alle Donuts animieren
document.querySelectorAll('.donut').forEach(animateDonut);


// ── Timetable: tabs + sticky ──────────────────────────────────────────────────
function gssInitTimetable(root) {
  if (!root) return;

  // Tab switching
  root.querySelectorAll('.timetable__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      root.querySelectorAll('.timetable__tab').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      root.querySelectorAll('.timetable__panel').forEach(function (p) {
        p.classList.remove('is-active');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      var panel = document.getElementById(tab.getAttribute('data-target'));
      if (panel) panel.classList.add('is-active');
    });
  });

  // JS sticky tabs (CSS sticky broken by body { overflow-x: hidden })
  var tabs = root.querySelector('.timetable__tabs');
  if (tabs) {
    var sentinel = document.createElement('div');
    sentinel.className = 'timetable__tabs-sentinel';
    tabs.parentNode.insertBefore(sentinel, tabs);
    var HEADER_H = parseInt(getComputedStyle(root).getPropertyValue('--tt-header-h')) || 90;
    function gssTabsSticky() {
      var rect = sentinel.getBoundingClientRect();
      if (rect.top < HEADER_H) {
        if (!tabs.classList.contains('is-sticky')) {
          sentinel.style.height = tabs.offsetHeight + 'px';
          tabs.classList.add('is-sticky');
        }
      } else {
        if (tabs.classList.contains('is-sticky')) {
          tabs.classList.remove('is-sticky');
          sentinel.style.height = '0';
        }
      }
    }
    window.addEventListener('scroll', gssTabsSticky, { passive: true });
    gssTabsSticky();
  }
}

document.querySelectorAll('.timetable').forEach(gssInitTimetable);